/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceSocialEmbedConfig
 */
export interface SurfaceSocialEmbedConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialEmbedConfig
     */
    platform?: SurfaceSocialEmbedConfigPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialEmbedConfig
     */
    embedUrl?: string;
}


/**
 * @export
 */
export const SurfaceSocialEmbedConfigPlatformEnum = {
    twitter: 'twitter',
    tiktok: 'tiktok',
    youtube: 'youtube',
    instagram: 'instagram'
} as const;
export type SurfaceSocialEmbedConfigPlatformEnum = typeof SurfaceSocialEmbedConfigPlatformEnum[keyof typeof SurfaceSocialEmbedConfigPlatformEnum];


/**
 * Check if a given object implements the SurfaceSocialEmbedConfig interface.
 */
export function instanceOfSurfaceSocialEmbedConfig(value: object): value is SurfaceSocialEmbedConfig {
    return true;
}

export function SurfaceSocialEmbedConfigFromJSON(json: any): SurfaceSocialEmbedConfig {
    return SurfaceSocialEmbedConfigFromJSONTyped(json, false);
}

export function SurfaceSocialEmbedConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceSocialEmbedConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'] == null ? undefined : json['platform'],
        'embedUrl': json['embedUrl'] == null ? undefined : json['embedUrl'],
    };
}

export function SurfaceSocialEmbedConfigToJSON(json: any): SurfaceSocialEmbedConfig {
    return SurfaceSocialEmbedConfigToJSONTyped(json, false);
}

export function SurfaceSocialEmbedConfigToJSONTyped(value?: SurfaceSocialEmbedConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'embedUrl': value['embedUrl'],
    };
}

